import { render, staticRenderFns } from "./SiteDocumentDetailsNewForm.vue?vue&type=template&id=b5fda016&"
import script from "./SiteDocumentDetailsNewForm.vue?vue&type=script&lang=js&"
export * from "./SiteDocumentDetailsNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports